import axios from "axios";
import API from "../api/url";
import * as CryptoJS from "crypto-js"; // Gunakan ini untuk ES Module (ESM)
import RESOURCE from "../api/var";

export const PerkimLogin = async () => {
    const AUTHDATA = {
        user: "admin@admin.com",
        password: "ijUY76Tijknnbvcft6t",
    };

    let formData = new FormData();
    formData.append("email", AUTHDATA.user);
    formData.append("password", AUTHDATA.password);
    await axios({
        method: "post",
        url: `${API.JS_PERKIM}auth`,
        data: formData,
        headers: {
        Accept: "application/json",
        },
    }).then((response) => {
        const { token } = response.data;
        localStorage.setItem("jstoken", token);
    }).catch((error) => {
        localStorage.setItem("jstoken", "");
    });

};

export const HousingLogin = async () => {
    const key = CryptoJS.enc.Utf8.parse(RESOURCE.KEY);
    const iv = CryptoJS.enc.Utf8.parse(RESOURCE.IV);
    const text = `${RESOURCE.USER}:${RESOURCE.PASS}`;
    const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(text), key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }).ciphertext.toString(CryptoJS.enc.Base64);
    await axios(
        {
            method: 'post',
            url: API.HOUSING_CLINIC + 'login',
            data: {
                data: encrypted
            }
        }
    ).then((response) => {
        const { token } = response.data;
        console.log(token);
        localStorage.setItem("housingtoken", token);
    }).catch((err) => {
        localStorage.setItem("housingtoken", "");
    });
}

// export default PerkimLogin;
